import React, { useState, useEffect } from 'react';
import useChatStore from '../store/useChatStore';

const OTPPage = () => {
  const { signIn, setCurrentScreen } = useChatStore();

  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [timer, setTimer] = useState(0);
  const [otpSent, setOtpSent] = useState(false);

  useEffect(() => {
    let interval;
    if (otpSent && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [otpSent, timer]);

  const handleSendOtp = () => {
    if (email) {
      setOtpSent(true);
      setTimer(10); // Start 60-second timer
      alert(`OTP sent to ${email}`); // Simulate OTP sending
    } else {
      alert('Please enter your email');
    }
  };

  const handleLogin = () => {
    if (otp) {
      signIn();
      setCurrentScreen('orderList'); // Navigate to the Order List screen
    } else {
      alert('Please enter the OTP sent to your email');
    }
  };

  return (
    <div className="login-page">
      {/* Email Input */}
      <input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="form-input"
      />

      {/* OTP Input and Send Button */}
      <div className="otp-container">
        <input
          type="text"
          placeholder="Enter code"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          className="form-input otp-input"
          style={{ marginBottom: 0 }}
        />
        <button
          className="otp-send-btn"
          onClick={handleSendOtp}
          disabled={otpSent && timer > 0}
        >
          {otpSent && timer > 0 ? `${timer}s` : 'Send'}
        </button>
      </div>

      {/* Login Button */}
      <button onClick={handleLogin} className="form-button">
        Log in
      </button>

      {/* Footer Text */}
      <p className="login-footer" onClick={() => setCurrentScreen('track-order')}>Use order# to track</p>
    </div>
  );
};

export default OTPPage;
